module.exports = __webpack_public_path__ + "img/left_top_lan.443aa307.png";